import { render } from "./Breadcrumb.vue?vue&type=template&id=3a872d8a&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=3a872d8a&lang=scss&scoped=true"

import exportComponent from "D:\\Dev\\Projects\\Web\\era-old.proj\\era.alpha-23-24.local\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a872d8a"]])

export default __exports__